import {CLMimeType} from '../media.types';
import mime from 'mime-types';

export default function getExtension(mimeType: CLMimeType) {
  if (mimeType === CLMimeType.MOV) return 'mov';
  if (mimeType === CLMimeType.JPG_SHORT) return 'jpg';
  if (mimeType === CLMimeType.APNG) return 'apng';
  if (mimeType === CLMimeType.SRT) return 'srt';

  return mime.extension(mimeType);
}
